import {Controller} from "stimulus"

/**
 * Reloads the enclosing Turbo Frame with an updated per_page query parameter.
 */
export default class extends Controller {
    change(event) {
        const turboFrame = this.element.closest("turbo-frame");
        if (!turboFrame || !turboFrame.src) return;

        const url = new URL(turboFrame.src, window.location.origin);
        url.searchParams.set("per_page", event.target.value);
        url.searchParams.delete("page");
        turboFrame.src = url.toString();
    }
}
